"use client";

import Link from "next/link";
import { AnimatedGroup } from "@/components/ui/animated-group";
import { ROOT_AUTH_URL, ROOT_PRIORITY_URL } from "@/constants/url";
import { AuroraBackground } from "./aurora-background";
import { DashboardMockup } from "./dashboard-mockup";

export function Hero() {
  return (
    <section className="relative min-h-screen w-full flex flex-col items-center justify-start pt-28 md:pt-36 overflow-hidden px-6">
      {/* Интерактивный aurora-фон */}
      <AuroraBackground />

      {/* Контент */}
      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <AnimatedGroup preset="blur-slide" className="flex flex-col items-center gap-6">
          {/* Бейдж — актуальный контекст апреля 2026 */}
          <div className="inline-flex items-center gap-2 rounded-full border border-white/[0.08] bg-white/[0.03] px-4 py-2">
            <span className="h-2 w-2 rounded-full bg-red-400 animate-pulse" />
            <span className="text-sm text-white/50">Комиссии выросли до 50%. Вы уверены, что в плюсе?</span>
          </div>

          {/* Заголовок — бьёт в главную боль */}
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold tracking-tight leading-[1.1]">
            <span
              className="block"
              style={{
                background: "linear-gradient(to bottom, #ffffff, #ffffff, rgba(255,255,255,0.6))",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
                letterSpacing: "-0.04em",
              }}
            >
              Вы точно знаете,
            </span>
            <span
              className="block"
              style={{
                background: "linear-gradient(to bottom, #ffffff, rgba(255,255,255,0.5))",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
                letterSpacing: "-0.04em",
              }}
            >
              какие товары вас кормят?
            </span>
          </h1>

          {/* Подзаголовок — конкретика */}
          <p className="text-base md:text-lg text-white/60 max-w-xl leading-relaxed">
            При комиссиях 50% и рекламе 15-25% от выручки — один убыточный
            артикул может съедать прибыль всего магазина. MPUNIT покажет
            прибыль по каждому товару и размеру за 15 минут.
          </p>

          {/* CTA */}
          <Link
            href={`${ROOT_AUTH_URL}/login?redirect_path=${ROOT_PRIORITY_URL}&no_return=0`}
            className="inline-flex items-center justify-center bg-white text-black rounded-lg px-6 py-3 font-semibold text-sm hover:bg-white/90 transition-colors"
          >
            Попробовать бесплатно
          </Link>
        </AnimatedGroup>
      </div>

      {/* Интерактивный мокап дашборда */}
      <DashboardMockup />
    </section>
  );
}
